import React from "react";

import Button from "../controls/button/styled-button";

import { textChooser } from "../../util/textChooser";

import { FormStepContainer, FormStepHeader } from "./styled-form-step";

interface FormStepCardProps {
  children: React.ReactChild;
  title: string;
  showBackButton?: boolean;
  handleBackButton?: () => void;
  className?: string;
  testId?: string;
}

export const FormStepCard = ({ showBackButton, handleBackButton, children, title, }: FormStepCardProps) => {
  return (
    <FormStepContainer>
      <FormStepHeader>
        {showBackButton && <Button onClick={handleBackButton} buttonStyle="goback">{textChooser("txt43")}</Button>}

        <h3>{title}</h3>
      </FormStepHeader>

      <div className="form-body">
        {children}
      </div>
    </FormStepContainer>
  )
}